<script setup>

import Search from "@/components/Search.vue";
</script>

<template>
  <div class="em40_header_area_main">
    <div class="kurigram-header-top">
      <div class="container">
        <div class="row">
          <div class=" col-lg-9 col-md-9 col-sm-12">
            <div class="top-address text-left">
              <p>
                <span><i class="fas fa-home"></i>Foshan TianPuAn Building Materials Technology Co.,Ltd.</span>
                <a href="#"><i class="fas fa-phone-alt"></i>+86 13929163028</a>
              </p>
            </div>
          </div>
          <!-- TOP RIGHT -->
          <div class="col-lg-3  col-md-3 col-sm-12 ">
            <div class="top-right-menu">
              <ul class="social-icons text-right text_m_center">
                <li><a href="https://www.facebook.com/profile.php?id=100083074701518"><i class="fa fa-facebook-f"></i></a></li>
                <li><a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i class="fab fa-youtube"></i></a></li>
                <li><a href="https://www.linkedin.com/company/84045662/admin/"><i class="fab fa-linkedin"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- END HEADER TOP AREA -->
    <div class="tx_top2_relative">
      <div class="">
        <div class="tx_relative_m">
          <div class="">
            <div class="mainmenu_width_tx">
              <div class="kurigram-main-menu one_page hidden-xs hidden-sm witr_search_wh witr_h_h20">
                <div class="kurigram_nav_area scroll_fixed postfix">
                  <div class="container">
                    <div class="row logo-left">
                      <div class="col-md-3 col-sm-3 col-xs-4">
                        <div class="logo">
                          <a class="main_sticky_main_l" href="/" title="tpahousing">
                            <img src="/assets/images/tpa3.png" alt="tpahousing" style="width: 100px; height: 100px;">
                          </a>
                          <a class="main_sticky_l" href="/" title="tpahousing">
                            <img src="/assets/images/tpa3.png" alt="tpahousing" style="width: 100px; height: 100px;">
                          </a>
                        </div>
                      </div>
                      <div class="col-md-9 col-sm-9 col-xs-8">
                        <div class="tx_mmenu_together">
                          <nav class="kurigram_menu nologo_menu13">
                            <ul class="sub-menu">
                              <li>
                                <a href="/">Home</a>
                              </li>
                              <li><a href="/about">About</a></li>
                              <li>
                                <a href="/projects">Projects</a>
                              </li>
                              <li>
                                <a href="/blogs">Blog</a>
                              </li>
                              <li><a href="/contact">Contact</a></li>
                            </ul>
                          </nav>
                          <div class="main-search-menu">
                            <div class="em-quearys-top msin-menu-search">
                              <div class="em-top-quearys-area">
                                <div class="em-header-quearys">
                                  <div class="em-quearys-menu">
                                    <i class="fa fa-search t-quearys em-s-hiddens"></i>
                                  </div>
                                </div>
                                <!--SEARCH FORM-->
                                <Search/>
                              </div>
                            </div>
                          </div>
                          <div class="donate-btn-header">
                            <a class="dtbtn" href="/projects">View projects</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- MOBILE MENU Logo AREA -->
  <div class="mobile_logo_area hidden-md hidden-lg">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="mobile_menu_logo text-center">
            <a href="/" title="kurigram">
              <img src="/assets/images/tpa3.png" alt="tpahousing" style="width: 100px; height: 100px">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MOBILE MENU AREA -->
  <div class="home-2 mbm hidden-md hidden-lg  header_area main-menu-area">
    <div class="menu_area mobile-menu">
      <nav class="kurigram_menu">
        <ul class="sub-menu">
          <li>
            <a href="/">Home</a>
          </li>
          <li><a href="/">About</a></li>
          <li class="menu-item-has-children">
            <a href="/">projects</a>
            <ul class="sub-menu">
              <li><a href="/">steel structure</a></li>
              <li><a href="/">steel home</a></li>
            </ul>
          </li>
          <li>
            <a href="/">Blog</a>
          </li>
          <li><a href="/">Contact</a></li>
        </ul>
      </nav>
    </div>
  </div>
  <!-- END MOBILE MENU AREA  -->
</template>

<style scoped lang="scss">

</style>